export default "__VITE_ASSET__DheborUO__"